import React, { Component } from "react";
import { Button } from "../../../common/Button/Button";
import CheckBoxContainer from "../../../common/CheckboxContainer/CheckboxContainer"
import moment from 'moment';

class SelectServiceRequestNamesDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      headerTitle: this.props.title
    };
  }

  

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        document.addEventListener("click", this.close);
      } else {
        document.removeEventListener("click", this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.close);
  }

  close = (e) => {
    if(this.dropdown.contains(e.target)){
      return
    }
    this.setState({
      listOpen: false
    });
  }

  toggleList() {
    this.setState(prevState => ({
      listOpen: !prevState.listOpen
    }));
  }

  renderServiceRequestNames = () => {
    // const {auditLog = []} = this.props;
      return(
        <div><CheckBoxContainer showSelectAll={true} toggleAll = {this.props.toggleAll} toggleSelection = {this.props.toggleSelection} checkboxItemsList={this.props.checkboxItemsList}/></div>
      )
    
  }

  

  
  render() {
    const { listOpen } = this.state;
    return (
      <div ref={elem => this.dropdown = elem}>
        <Button className="inline-button" onClick={() => this.toggleList()}>Select Service Requests</Button>
        {listOpen && (
          <div className="dd-list selectServiceType">
            <div>
              {this.renderServiceRequestNames()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SelectServiceRequestNamesDropdown;
